import { useFormikContext } from "formik";
import { useSelector } from "react-redux";
import { Col, Row } from "reactstrap";
import { formProps } from ".";
import { Input } from "../../components";
import { getLocalization } from "../../redux/localization";

const Step1 = () => {
  const { handleBlur, values, errors, touched, handleChange } =
    useFormikContext<formProps>();
  const t = useSelector(getLocalization);
  return (
    <div className="w-100 px-3 py-2">
      <Row className="contactUsForm">
        <Col md={6}>
          <Input
            value={values.Name}
            placeholder={t.getString(`Name`) + "*"}
            onChange={handleChange("Name")}
            onBlur={handleBlur("Name")}
            error={errors.Name}
            touched={touched.Name}
          />
        </Col>
        <Col md={6}>
          <Input
            value={values.Surname}
            placeholder={t.getString(`Surname`) + "*"}
            onChange={handleChange("Surname")}
            onBlur={handleBlur("Surname")}
            error={errors.Surname}
            touched={touched.Surname}
          />
        </Col>
        <Col md={6}>
          <Input
            value={values.Email}
            placeholder={t.getString(`Email`) + "*"}
            onChange={handleChange("Email")}
            onBlur={handleBlur("Email")}
            touched={touched.Email}
            error={errors.Email}
          />
        </Col>
        <Col md={6}>
          <Input
            value={values.IdentityNumber}
            placeholder={t.getString(`IdentityNumber`) + "*"}
            onChange={handleChange("IdentityNumber")}
            onBlur={handleBlur("IdentityNumber")}
            error={errors.IdentityNumber}
            touched={touched.IdentityNumber}
          />
        </Col>
      </Row>
    </div>
  );
};
export default Step1;
